module.exports = __webpack_public_path__ + "static/media/background.e9a9c975.png";